import React from 'react';
import { useHistory } from 'react-router-dom';
import { Table, TableCell, TableCellDropdown, Dropdown, TooltipHelp, Icon, Tooltip } from '@weezevent/nacre';
import { typesKeyNames } from '../helper';
import { useTranslation } from 'react-i18next';
import Style from '../template-row/templateRow.module.css';

const LinkedRulesColumn = React.memo(({ level, rules, t }) => {
    if (!rules.length) return '-';

    const countRules = (rule_type, rules) => {
        return rules.reduce((count, rule) => {
            if (rule[rule_type]) count++;
            return count;
        }, 0);
    };
    const numberRulesRates = countRules('rate_id', rules);
    const numberRulesEvents = countRules('event_id', rules);
    const numberRulesOrga = countRules('organization_id', rules);

    if ((level === 'event' && numberRulesRates > 0) || (level === 'orga' && numberRulesEvents > 0))
        return <>{t(`ticket.ticket_design.designs.${level === 'event' ? 'tickets' : 'events'}.total`, { count: level === 'event' ? numberRulesRates : numberRulesEvents })}</>;
    if ((level === 'event' && numberRulesEvents > 0) || (level === 'orga' && numberRulesOrga > 0))
        return (
            <>
                {t('ticket.ticket_design.designs.tickets.default')}
                <TooltipHelp title={t(`ticket.ticket_design.designs.${level === 'event' ? 'tickets' : 'events'}.tooltip`)} />
            </>
        );
    return '-';
});

export function DesignRow({ level = 'orga', event, design, organization = {}, selectedDesigns = {}, onSelected = () => {}, setModaleType = () => {}, isReadOnly = true }) {
    const { t } = useTranslation();
    const eventprefix = React.useMemo(() => {
        return `/ticket/O${organization?.id}/E${event?.id}/settings/tickets_design/designs`;
    }, [organization, event]);
    const orgaPrefix = React.useMemo(() => {
        return `/ticket/O${organization?.id}/tickets_design/designs`;
    }, [organization]);
    const history = useHistory();
    const isLocked = level === 'event' && !design.event_id;

    return (
        <Table.Tr
            active={Boolean(selectedDesigns[design.pk])}
            onSelected={(event, data) => onSelected({ event, data }, design)}
            onClick={() => history.push(`${event && !isLocked ? eventprefix : orgaPrefix}/${design.pk}`)}
        >
            <Table.Td className="external-links">
                {design.name}{' '}
                {isLocked && (
                    <a className="link" href={`${orgaPrefix}/${design.pk}`}>
                        <Icon
                            name="link"
                            onClick={() => {
                                history.push(`${orgaPrefix}/${design.pk}`);
                            }}
                        />
                    </a>
                )}
            </Table.Td>
            <Table.Td>{t(`ticket.ticket_design.type.${typesKeyNames[design.template.type]}`)}</Table.Td>
            <Table.Td>{design.template.name}</Table.Td>
            <Table.Td>
                <LinkedRulesColumn level={level} rules={design.rules} t={t} />
            </Table.Td>
            <TableCell style={{ paddingLeft: 0 }} className={Style['icon-action-cell']}>
                <Tooltip margin={false} triggerOnHover title={t(`ticket.ticket_design.designs.linked_${level === 'event' ? 'ticket' : 'event'}.linked`)} visible>
                    <Icon disabled={isLocked} name="list" margin={false} onClick={() => setModaleType({ action: 'preview', selected: [design] })} />
                </Tooltip>
            </TableCell>
            <TableCellDropdown className={Style['dropdown-action-cell']}>
                <Dropdown.Item disabled={isReadOnly} onClick={() => history.push(`${event && !isLocked ? eventprefix : orgaPrefix}/${design.pk}`)}>
                    {t('ticket.common.action.edit')}
                </Dropdown.Item>
                <Dropdown.Item disabled={isLocked || isReadOnly} onClick={() => setModaleType({ action: 'duplicate', selected: [design] })}>
                    {t('ticket.common.action.duplicate')}
                </Dropdown.Item>
                <Dropdown.Item disabled={isLocked} onClick={() => setModaleType({ action: 'preview', selected: [design] })}>
                    {t(`ticket.ticket_design.designs.modale.preview_${level === 'event' ? 'tickets' : 'events'}`)}
                </Dropdown.Item>
                <Dropdown.Line />
                <Dropdown.Item disabled={isLocked || isReadOnly} onClick={() => setModaleType({ action: 'delete', selected: [design] })} deleteItem>
                    {t('ticket.common.action.delete')}
                </Dropdown.Item>
            </TableCellDropdown>
        </Table.Tr>
    );
}
